<div class="modal-header">
    <h4 class="modal-title">Confirmation de suppression</h4>
    <button type="button" class="close" (click)="activeModal.dismiss()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Êtes-vous sûr de vouloir supprimer l'utilisateur <strong>{{ utilisateur.nom }} {{ utilisateur.prenom }}</strong> ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-danger" (click)="delete()">Supprimer</button>
  </div>
  